import React from 'react';
import { Stack, Typography, Box } from '@mui/material';

interface InfoLineProps {
  title: string;
  value: string | React.ReactNode;
  compact?: boolean;
}

const InfoLine: React.FC<InfoLineProps> = ({ title, value, compact }) => (
  <Stack
    direction="row"
    sx={{
      py: compact ? 0.4 : 1,
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative'
    }}
  >
    <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 600 }}>{title}</Typography>
    <Box 
      sx={{ 
        flex: 1, 
        height: '1px', 
        backgroundColor: '#F7F7F7',
        mx: 2
      }} 
    />
    <Typography sx={{ 
      fontSize: 12, 
      color: '#656565', 
      fontWeight: 400,
      textAlign: 'right'
    }}>
      {value}
    </Typography>
  </Stack>
);

export default InfoLine;